const aiHub = {
  modeChat: "Chat",
  modeChatDesc: "General conversation with the assistant",
  modeAnalyze: "Analyze",
  modeAnalyzeDesc: "Analyze project data and health scores",
  modeWrite: "Write",
  modeWriteDesc: "Draft documents, emails and reports",
  modeDecompose: "Decompose",
  modeDecomposeDesc: "Break epics into stories and tasks",
  modeWork: "Work Manager",
  modeWorkDesc: "GAM's work manager — knows what exists, what's open, and what to do next",
  workConnected: "Connected",
  workDisconnected: "Disconnected",
  workSuggestStatus: "What's the project status?",
  workSuggestNext: "What's the next task?",
  workSuggestDecisions: "What were the latest decisions?",
  workSuggestPriority: "What's the highest priority right now?",
  confidenceHigh: "Confident",
  confidenceMedium: "Likely",
  confidenceLow: "Uncertain",
  actionConfirm: "Confirm",
  actionCancel: "Cancel",
  actionPreviewTitle: "Confirm Action",
  newChat: "New Chat",
  conversations: "Conversations",
  noConversations: "No conversations yet",
  emptyChat: "Select a mode and start a conversation",
  context: "Context",
  addContext: "Add context",
  sendMessage: "Send",
  typePlaceholder: "Type a message...",
  charCount: "characters",
  suggestChatStatus: "What's the status today?",
  suggestChatSummarize: "Summarize active projects",
  suggestAnalyzeHealth: "Analyze health scores",
  suggestAnalyzeAttention: "What needs attention?",
  suggestWriteReport: "Write a weekly report",
  suggestWriteEmail: "Draft a client email",
  suggestDecomposeEpic: "Decompose epic into stories",
  suggestDecomposeTasks: "Create tasks from a feature",
  thinking: "Thinking...",
  mockDisclaimer: "Demo mode — sample responses",
  deleteConversation: "Delete conversation",
  untitled: "Untitled conversation",
  streaming: "Responding...",
  stopGeneration: "Stop",
  tokenUsage: "Daily token usage",
  tokenBudgetWarning: "80% of daily budget used",
  tokenBudgetExceeded: "Daily budget exceeded — try again tomorrow",
  liveMode: "Live",
  modelLabel: "Model",
  conversationLimit: "50-message limit reached — start a new chat",
  savingToCloud: "Saving...",
  savedToCloud: "Saved to cloud",
  offlineMode: "Offline mode",
  toolbarBold: "Bold",
  toolbarItalic: "Italic",
  toolbarStrikethrough: "Strikethrough",
  toolbarCode: "Code",
  toolbarLink: "Link",
  toolbarBulletList: "Bullet List",
  toolbarNumberedList: "Numbered List",
  toolbarConvertLang: "Convert Language",
  toolbarConvertTooltip: "Fix Hebrew/English keyboard",
  agentOrchestrator: "Orchestrator",
  agentPm: "PM Bot",
  agentDev: "Dev Bot",
  agentDesign: "Design Bot",
  agentQa: "QA Bot",
  agentStrategy: "Strategy Bot",
  // AI Hub Pro — new keys
  knowledgeBase: "Knowledge Base",
  knowledgeDescription: "Add URLs as knowledge for this mode — AI will reference their content in conversations",
  addUrl: "Add",
  invalidUrl: "Invalid URL",
  urlLimit: "Maximum 5 URLs per mode",
  urlDuplicate: "URL already added",
  urlFetchFailed: "Could not fetch URL",
  searchConversations: "Search conversations...",
  docPanel: "Document",
  searchDocument: "Search document...",
  noDocSelected: "Select a document to view",
  attachImage: "Attach image",
  dropImageHere: "Drop image here",
  replyTo: "Reply",
  cancelReply: "Cancel reply",
  mentionEntity: "Search entity...",
  recentEntities: "Recent",
  noEntitiesFound: "No entities found",
  copyMessage: "Copy",
  regenerate: "Regenerate",
  // Action Preview
  actionExecuting: "Executing...",
  actionSuccess: "Done",
  actionError: "Failed",
  actionRetry: "Retry",
  actionNotionTask: "Notion Task",
  // Personas
  personaSelector: "Advisor",
  noPersona: "No advisor",
  selectPersona: "Select advisor",
  clearPersona: "Clear",
  domainOperations: "Operations",
  domainFinance: "Finance",
  domainLegal: "Legal",
  domainHr: "HR",
  domainMarketing: "Marketing",
  domainTech: "Tech",
  domainStrategy: "Strategy",
  domainGeneral: "General",
} as const;
export default aiHub;
